var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOurPlatformIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 272,
    viewBox: "0 0 288 272",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M264.985 70.9051C275.384 77.1124 275.384 92.1745 264.985 98.3819L149.997 167.023C144.945 170.038 138.646 170.038 133.595 167.023L23.0148 101.013C12.6161 94.8059 12.6161 79.7439 23.0148 73.5365L138.003 4.89549C143.055 1.88003 149.354 1.88003 154.405 4.89549L264.985 70.9051Z",
    fill: "#03C988"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.875 121.076L151.489 188.761C146.437 191.776 140.138 191.776 135.087 188.761L26.1089 123.708L24.5065 124.664C14.1078 130.872 14.1079 145.934 24.5065 152.141L135.087 218.151C140.138 221.166 146.437 221.166 151.489 218.151L266.477 149.51C276.876 143.302 276.876 128.24 266.477 122.033L264.875 121.076Z",
    fill: "#03C988"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.875 171.918L151.489 239.602C146.437 242.618 140.138 242.618 135.087 239.602L26.1089 174.549L24.5065 175.506C14.1078 181.713 14.1079 196.775 24.5065 202.983L135.087 268.992C140.138 272.008 146.437 272.008 151.489 268.992L266.477 200.351C276.876 194.144 276.876 179.082 266.477 172.875L264.875 171.918Z",
    fill: "#03C988"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurPlatformIcon);
export default __webpack_public_path__ + "static/media/our-platform-icon.679a161e267c815d517d89465068d70c.svg";
export { ForwardRef as ReactComponent };